import { DynamicVariableIcon } from '../icons';
import List from './List';

export default {
	options: {
		group: "dashboard",
		roles: ["user", "admin"],
	},
	icon: DynamicVariableIcon,
	list: List,
};
